<template>
  <!--  <div style="display: block" class="scroll-to-top scroll-to-target" data-target="html">-->
  <!--    <span class="icon flaticon-up-arrow-angle"></span>-->
  <!--  </div>-->
  <el-backtop right="20" class="back_top">
    <span class="icon flaticon-up-arrow-angle"></span>
    <!--        <div class="backtop_arrow"></div>-->
  </el-backtop>
  <!-- Main Footer -->
  <footer class="main-footer">
    <!-- Footer Bottom -->
    <div class="footer-bottom">
      <div class="auto-container">
        <div class="inner">
          <div class="logo" style="width:100px;">
            <router-link to="/">
							<img v-if="URLTYPE == 'sbipro'" src="/images/logo_SBIPRO.png" alt="" />
            </router-link>
          </div>
          <!-- ak -->
          <!-- <div class="copyright" v-if="URLTYPE == 'ak'">
            Copyright © 2025 ABU KHEMA PETROLEUM All rights reserved.
          </div> -->
          <!-- EBN： -->
          <!-- <div class="copyright" v-if="URLTYPE == 'ebn'">
            Copyright © 2025 Zhongman Middle East All rights reserved.
          </div> -->
          <!-- MF： -->
          <!-- <div class="copyright" v-if="URLTYPE == 'mf'">
            Copyright © 2025 Zhongman Babylon All rights reserved.
          </div> -->
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      URLTYPE: this.$store.screen.URLTYPE,
    }
  },
}
</script>

<style lang="scss" scoped>
</style>
